import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { Logout } from '@mui/icons-material';

interface LogoutButtonProps {
  onLogout: () => void;
  position?: 'fixed' | 'absolute' | 'relative';
  top?: number | string;
  right?: number | string;
  zIndex?: number;
  isDarkMode?: boolean;
}

const LogoutButton: React.FC<LogoutButtonProps> = ({
  onLogout,
  position = 'fixed',
  top = 24,
  right = 24,
  zIndex = 1000,
  isDarkMode = true,
}) => {
  return (
    <Box
      sx={{
        position,
        top,
        right,
        zIndex,
      }}
    >
      <Tooltip title="Sign out of your account">
        <IconButton
          onClick={onLogout}
          sx={{
            background: isDarkMode ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
            backdropFilter: 'blur(20px)',
            color: isDarkMode ? 'white' : '#64748b',
            border: isDarkMode ? '1px solid rgba(255, 255, 255, 0.2)' : '1px solid rgba(0, 0, 0, 0.1)',
            p: 1.5,
            '&:hover': {
              background: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(239, 68, 68, 0.1)',
              color: '#ef4444',
              transform: 'scale(1.05)',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            },
            transition: 'all 0.3s ease',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Logout sx={{ fontSize: 24 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default LogoutButton;
